import React, { useState, useEffect } from "react";
import {
  Container,
  Dropdown,
  DropdownMenu,
  DropdownToggle,
  Nav,
  Navbar,
  Offcanvas,
} from "react-bootstrap";
import Images from "../Images";
import { Link } from "react-router-dom";
import { FaMoon, FaSun } from "react-icons/fa";
import { IoPersonCircleOutline } from "react-icons/io5";
import Announcement from "./Announcement";
import Subheader from "./Subheader";
import DetailHeader from "./DetailHeader";
import { useSelector, useDispatch } from "react-redux";
import { toggleTheme } from "../Redux/action";
import { getHeaderData } from "../Actions/v1/user";
import { setHeader } from "../Redux/user.action";
import { isEmpty } from "../Actions/commonFunction";
import config from '../config/config'
function Header() {
  const theme = useSelector((state) => state.theme.theme);
  console.log("sdsadsa", theme);
  const {account} = useSelector(state=>state?.user)

  const dispatch = useDispatch();

  const [showDropdown, setShowDropdown] = useState(false);
  const [showDropdown1, setShowDropdown1] = useState(false);
  const [showSubDropdown, setShowSubDropdown] = useState(false);
  const [showSubDropdown1, setShowSubDropdown1] = useState(false);
  const [showSubDropdown2, setShowSubDropdown2] = useState(false);

  const [menuOpen, setMenuOpen] = useState(false); // initially closed

  const [Details, setDetails] = useState({});
  console.log("🚀 ~ Header ~ Details:", Details);

  useEffect(() => {
    document.body.className = theme == "dark" ? "dark-theme" : "";
  }, [theme]);

  const getData = async () => {
    let resp = await getHeaderData();
    console.log("🚀 ~ getData ~ resp:", resp);
    if (resp?.status) {
      dispatch(setHeader(resp?.data));
    }
  };

  useEffect(() => {
    getData();
  }, []);

  return (
    <div className="header">
      <Navbar key="xl" expand="xl">
        <Container className="head_contain">
          <Navbar.Brand className="ps-0 ps-xl-0">
            <Link to="/">
              <img
                src={Images.logo}
                alt="logo"
                className="img-fluid edafacelogo"
              />
            </Link>
            <Link to="/">
              <img
                src={Images.listing}
                alt="logo"
                className="img-fluid listinglogo  img mt-1 ms-3"
              />
            </Link>
          </Navbar.Brand>
          <Navbar.Toggle
            aria-controls={`offcanvasNavbar-expand-xl`}
            onClick={() => setMenuOpen(!menuOpen)}
          />
          <Navbar.Offcanvas
            id={`offcanvasNavbar-expand-xl`}
            aria-labelledby={`offcanvasNavbarLabel-expand-xl`}
            placement="end"
            restoreFocus={false}
            show={menuOpen}
            onHide={() => setMenuOpen(!menuOpen)}
          >
            <Offcanvas.Header closeButton>
              <Offcanvas.Title id={`offcanvasNavbarLabel-expand-xl`}>
                <Link to="/">
                  <img
                    src={Images.listing}
                    alt="logo"
                    className="img-fluid logomobimg ms-2"
                  />
                </Link>
              </Offcanvas.Title>
            </Offcanvas.Header>
            <Offcanvas.Body className="align-items-center justify-content-between">
              <Nav className="justify-content-end mt-1  pe-3">
                <Link className="tokena" to="">
                  $EDA
                </Link>
                <Dropdown
                  className="edaface_drop"
                  onMouseLeave={() => setShowDropdown(false)}
                  onMouseOver={() => setShowDropdown(true)}
                >
                  <DropdownToggle>EdaFace Ecosystem</DropdownToggle>
                  <DropdownMenu className="py-2 px-3" show={showDropdown}>
                    {/* <Link to="/">
                      <img
                        src={Images.doc}
                        className="me-2 navicon"
                        alt="icons"
                      />{" "}
                      Marketplace
                    </Link> */}
                     <Dropdown
      className="sub-dropdown mb-2 mb-xl-0"
      onMouseLeave={() => setShowSubDropdown(false)}
      onMouseOver={() => setShowSubDropdown(true)}
    >
      <DropdownToggle as="div" className="dropdown-item d-flex align-items-center px-0 mb-0 mb-xl-3">
        <img src={Images.doc} className="me-2 navicon" alt="icons" /> Marketplace
      </DropdownToggle>
      <DropdownMenu show={showSubDropdown} className="py-2 px-3 subdropmenu">
        <Link to="#"><img src={Images.square} className='me-2 navicon' alt="icons" />NFT</Link>
        <Link to="#"><img src={Images.square} className='me-2 navicon' alt="icons" />Blockchain Literature</Link>
        <Link to="#"><img src={Images.square} className='me-2 navicon' alt="icons" />Shopping Mall</Link>
      </DropdownMenu>
    </Dropdown>
                    
                    {/* <Link to="/">
                      <img
                        src={Images.doc}
                        className="me-2 navicon"
                        alt="icons"
                      />{" "}
                      Academy
                    </Link> */}
                      <Dropdown
      className="sub-dropdown mb-2 mb-xl-0"
      onMouseLeave={() => setShowSubDropdown1(false)}
      onMouseOver={() => setShowSubDropdown1(true)}
    >
      <DropdownToggle as="div" className="dropdown-item d-flex align-items-center px-0 mb-0 mb-xl-3">
        <img src={Images.doc} className="me-2 navicon" alt="icons" /> Academy
      </DropdownToggle>
      <DropdownMenu show={showSubDropdown1} className="py-2 px-3 subdropmenu">
        <Link to="#"><img src={Images.square} className='me-2 navicon' alt="icons" />Newsfeed</Link>
        <Link to="#"><img src={Images.square} className='me-2 navicon' alt="icons" />School of Cryptos</Link>
        <Link to="#"><img src={Images.square} className='me-2 navicon' alt="icons" />Forum</Link>
      </DropdownMenu>
    </Dropdown>
                    {/* <Link to="/">
                      <img
                        src={Images.doc}
                        className="me-2 navicon"
                        alt="icons"
                      />{" "}
                      Launchpad
                    </Link> */}
                      <Dropdown
      className="sub-dropdown"
      onMouseLeave={() => setShowSubDropdown2(false)}
      onMouseOver={() => setShowSubDropdown2(true)}
    >
      <DropdownToggle as="div" className="dropdown-item d-flex align-items-center px-0">
        <img src={Images.doc} className="me-2 navicon" alt="icons" /> VAC
      </DropdownToggle>
      <DropdownMenu show={showSubDropdown2} className="py-2 px-3 subdropmenu">
        <Link to="https://edafacevac.maticz.in/" target="_blank"><img src={Images.square} className='me-2 navicon' alt="icons" />List Your Project</Link>
        <Link to="#"><img src={Images.square} className='me-2 navicon' alt="icons" />Check Scam</Link>
      </DropdownMenu>
    </Dropdown>
                  </DropdownMenu>
                </Dropdown>
                <Link to="">Build On Edaface</Link>
                {/* <Link to="">Contact Us</Link> */}
                <div className="d-block d-xl-none">
                  <Subheader />
                </div>
              </Nav>

              <div className="d-flex align-items-center mob_gap ms-2 ms-xl-0">
                <div className="d-block d-xl-none mt-2">
                  <button className="themebtn rounded-1">Login</button>
                  <button className="themebtn rounded-1 ms-2">Register</button>
                </div>
                <button
                  className="themebtn rounded-1 pad_list  mt-2 mt-xl-0"
                  // onClick={toggleTheme}
                  onClick={() => {
                    dispatch(toggleTheme());
                    localStorage.setItem(
                      "theme",
                      theme == "dark" ? "light" : "dark"
                    );
                  }}
                >
                  {theme === "light" ? <FaSun /> : <FaMoon />}
                </button>
                <Dropdown
                  className="edaface_drop d-none d-xl-block"
                  onMouseLeave={() => setShowDropdown1(false)}
                  onMouseOver={() => setShowDropdown1(true)}
                >
                  <DropdownToggle>
                    <IoPersonCircleOutline className="person" />
                  </DropdownToggle>
                  <DropdownMenu
                    className="person_drop py-2 px-3"
                    show={showDropdown1}
                  >
                    {
                    isEmpty(account) ?
                    <>
                    <Link target="_blank" to={config.ssologin}>
                      <img
                        src={Images.square}
                        className="me-2 navicon"
                        alt="icons"
                      />{" "}
                      Login
                    </Link>
                    <Link target="_blank" to={config.ssologin}>
                      <img
                        src={Images.square}
                        className="me-2 navicon"
                        alt="icons"
                      />{" "}
                      Register
                    </Link>
                    </>
                    :
                    <>
                    <h6 className="themeclr">Mail:</h6>
                      <p className="mb-0">{account?.EmailId}</p>
                    {/* <p>{account?.EmailId}</p> */}
                    </>
                  }
                
                  </DropdownMenu>
                </Dropdown>
              </div>
            </Offcanvas.Body>
          </Navbar.Offcanvas>
        </Container>
      </Navbar>

      <div className="d-none d-xl-block">
        <Subheader />
      </div>

      <DetailHeader />

      <Announcement />
    </div>
  );
}

export default Header;
